import { ArrowDown } from "lucide-react";
import { Reveal } from "./Reveal";
import { Logo } from "./Logo";
import { linkProps } from "@/lib/api";
import { SecureCheckout } from "./PaymentBadges";

export const FinalCta = ({ s }) => (
  <section className="grain relative overflow-hidden py-32 lg:py-44" data-testid="final-cta">
    <img src="/img/streams.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-br from-blue-700/90 via-blue-600/75 to-cyan-500/80" />
    <Reveal className="relative mx-auto max-w-5xl px-5 text-center lg:px-8">
      <h2 className="font-display text-4xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-7xl">Your business.<br /><span className="text-[#FACC15]">Your rules.</span></h2>
      <p className="mx-auto mt-6 max-w-xl text-base text-blue-50 md:text-lg">Launch your own traffic exchange today for a single ${s.price} payment. No monthly fees.</p>
      <a {...linkProps(s.final_cta_url, "#pricing")} data-testid="final-pricing-link" className="mt-10 inline-flex items-center gap-2 rounded-full border-2 border-white px-7 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-white hover:text-blue-700">{s.final_cta_text} <ArrowDown className="h-4 w-4" /></a>
    </Reveal>
  </section>
);

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 py-12 md:flex-row md:items-center lg:px-8">
      <Logo testId="footer-logo" small />
      <div className="flex flex-wrap gap-6 text-sm font-semibold text-slate-600">
        <a href="#features" className="hover:text-blue-600" data-testid="footer-features-link">Features</a>
        <a href="#pricing" className="hover:text-blue-600" data-testid="footer-pricing-link">Pricing</a>
        <a href="#support" className="hover:text-blue-600" data-testid="footer-support-link">Support</a>
        <a href="/license-terms" className="hover:text-blue-600" data-testid="footer-license-terms-link">License terms</a>
      </div>
      <SecureCheckout variant="footer" />
    </div>
    <div className="border-t border-slate-100">
      <p className="mx-auto max-w-7xl px-5 py-6 text-center text-sm text-slate-500 lg:px-8" data-testid="footer-copyright">© {new Date().getFullYear()} Start-A-TE. All rights reserved.</p>
    </div>
  </footer>
);
